import React from 'react';
import { useStore } from '../../../../../stores/root';

// assets

// services

// props

// components
import { DefaultButton, Link, Panel, PanelType, SearchBox, Stack } from '@fluentui/react';
import Text from '../../../../typography/text';
import LoadingComponent from '../../../../feedbacks/loading';
import Label from '../../../../typography/label';
import CompanyService from '../../../../../services/users/company';

type SearchCompanyFormProps = {
    onDismissed(): void;
    onCreateNew(name: string): void;
}

const SearchCompanyForm: React.FC<SearchCompanyFormProps> = (props: SearchCompanyFormProps) => {
    const { banner, user } = useStore();
    const [searching, setSearching] = React.useState<boolean>(false);
    const [keyword, setKeyword] = React.useState<string>("");
    const [similarNames, setSimilarNames] = React.useState<string[]>([]);

    const _onSearch = async (value?: string) => {
        setSearching(true);
        setKeyword(value || "");

        if (value && value.trim() !== "") {
            try {
                const [_similarNames, _companies] = await Promise.all([
                    ((await CompanyService.findSimilar(`name=${value}`)) || []), 
                    (await CompanyService.retrieve(["search=" + value, "top=all"].join("&")))
                ]);

                const _loweredCaseNames: string[] = JSON.parse(JSON.stringify(_similarNames || [])).map((name: string) => name.toLowerCase());
                _companies.data.forEach((company) => {
                    if (_loweredCaseNames.indexOf(company.name.toLowerCase()) < 0) {
                        _similarNames.push(company.name)
                    }
                });

                setSimilarNames(_similarNames);
                setSearching(false);
            } catch(e) {}
        }
    }

    const _onRenderCompanyName = (name: string) => {
        return <Stack className={'card'}>
            <Label size={'xsmall'}>{name}</Label>
        </Stack>
    }

    return <Panel headerText={'Create Company'}
        isOpen={true}
        type={PanelType.medium}
        onDismiss={() => props.onDismissed()}
        onRenderFooterContent={() => {
            return <Stack horizontal tokens={{ childrenGap: 10 }}>
                <DefaultButton text={"Cancel"} onClick={() => { props.onDismissed() }} />
            </Stack>;
        }}
        isFooterAtBottom={true} >
        <Stack tokens={{childrenGap: 15}}>
            <Text>To ensure no companies are created multiple times, please type in company name that you are going to add to make sure it's not yet in the system.</Text>
            <SearchBox placeholder='Search company ...'
                value={keyword}
                onChange={(evt, value) => {
                    setKeyword(value || "");
                }}
                onSearch={_onSearch} />
            {searching ? <Stack className={'divider'} /> : null}
            {searching ? <LoadingComponent label={'Searching ...'} labelPosition={'right'} spinnerPosition={'baseline'} /> : null}
            {!searching && keyword.length > 0 && similarNames.length < 1 ? <Stack tokens={{childrenGap: 15}}>
                <Stack className={'divider'} />
                <Text size={'small'}>No companies found. <Link onClick={() => props.onCreateNew(keyword)}>click here</Link> to create new company.</Text>
            </Stack> : null}
            {!searching && keyword.length > 0 && similarNames.length > 0 ? <Stack tokens={{childrenGap: 15}}>
                <Stack className={'divider'} />
                <Text size={'small'}>{similarNames.length} companies with similar name found</Text>
                {similarNames.map(_onRenderCompanyName)}
                <Stack className={'divider'} />
                <Text size={'small'}>If you cannot find companies that you are looking for, <Link onClick={() => props.onCreateNew(keyword)}>click here</Link> to create new company.</Text>
            </Stack> : null}
        </Stack>
    </Panel>;
};

export default SearchCompanyForm;
